import { Shirt } from "lucide-react";
import { useMemo } from "react";

import { useArtworkForm } from "@design-lab/entities/artwork";
import { usePlacementPosition } from "@design-lab/widgets/artboard/model/usePlacementPosition";

import { BackShirtIcon } from "../ui/components/icons";
import { SHIRT_TAB_IDS, type TabId, type TabItem } from "./types/TabTypes";

export function useShirtTabs() {
  // Two-way binding with Artboard placement
  const { lens } = useArtworkForm();
  const currentPlacementLens = lens.focus("currentPlacement");
  const selectedFrontPlacementLens = lens.focus("selectedFrontPlacement");
  const currentPlacement = usePlacementPosition(currentPlacementLens);
  const selectedFrontPlacement = usePlacementPosition(selectedFrontPlacementLens);

  const tabs = useMemo<TabItem[]>(
    () => [
      {
        id: SHIRT_TAB_IDS.FRONT,
        label: "Front of Shirt",
        icon: <Shirt className="size-5" />,
        testId: "front-of-shirt-tab"
      },
      {
        id: SHIRT_TAB_IDS.BACK,
        label: "Back of Shirt",
        icon: <BackShirtIcon className="size-5" />,
        testId: "back-of-shirt-tab"
      }
    ],
    []
  );

  const handleTabChange = (tabId: TabId) => {
    if (tabId === SHIRT_TAB_IDS.BACK) {
      if (currentPlacement.placement !== SHIRT_TAB_IDS.BACK) {
        currentPlacement.setPlacement(SHIRT_TAB_IDS.BACK);
      }
      return;
    }

    const targetFrontPlacement = selectedFrontPlacement.placement || SHIRT_TAB_IDS.FRONT;
    if (currentPlacement.placement !== targetFrontPlacement) {
      currentPlacement.setPlacement(targetFrontPlacement);
    }
  };

  const activeTab: TabId =
    currentPlacement.placement === SHIRT_TAB_IDS.BACK ? SHIRT_TAB_IDS.BACK : SHIRT_TAB_IDS.FRONT;

  const activeTabData = tabs.find(tab => tab.id === activeTab);

  return {
    tabs,
    activeTab,
    activeTabData,
    handleTabChange
  };
}
